module.exports = __webpack_public_path__ + "static/media/SelfAwarenessOfValuesENG.d7ecf9d3.vtt";